import { Tag } from 'antd';
import { groupBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useModel } from 'umi';

// import socket from '@/services/socket';
import moment from 'moment';
import styles from './index.less';
import NoticeIcon from './NoticeIcon';
import socket from '@/services/ant-design-pro/socket';
import { getBrowserUniqueId } from '@/services/ant-design-pro';
import { getNotifications } from '@/services/ant-design-pro/user';
// import {DMTime} from '../../../config/setting';

export type GlobalHeaderRightProps = {
  fetchingNotices?: boolean;
  onNoticeVisibleChange?: (visible: boolean) => void;
  onNoticeClear?: (tabName?: string) => void;
};

const getNoticeData = (notices: API.NoticeIconItem[]): Record<string, API.NoticeIconItem[]> => {
  if (!notices || notices.length === 0 || !Array.isArray(notices)) {
    return {};
  }

  const newNotices = notices.map((notice) => {
    const newNotice = { ...notice };

    if (newNotice.datetime) {
      newNotice.datetime = notice.datetime;
    }

    if (newNotice.id) {
      newNotice.key = newNotice.id;
    }

    if (newNotice.extra && newNotice.status) {
      const color = {
        todo: '',
        processing: 'blue',
        urgent: 'red',
        doing: 'gold',
      }[newNotice.status];
      newNotice.extra = (
        <Tag
          color={color}
          style={{
            marginRight: 0,
          }}
        >
          {newNotice.extra}
        </Tag>
      ) as any;
    }

    return newNotice;
  });

  return groupBy(newNotices, 'type');
};

const getUnreadData = (noticeData: Record<string, API.NoticeIconItem[]>) => {
  const unreadMsg: Record<string, number> = {};
  Object.keys(noticeData).forEach((key) => {
    const value = noticeData[key];

    if (!unreadMsg[key]) {
      unreadMsg[key] = 0;
    }

    if (Array.isArray(value)) {
      unreadMsg[key] = value.filter((item) => !item.read).length;
    }
  });
  return unreadMsg;
};

const NoticeIconView: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  const [notices, setNotices] = useState<API.NoticeIconItem[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadMsg, setUnreadMsg] = useState(0);

  const noticeData = getNoticeData(notices);

  const changeReadState = (id: string) => {

    setNotices(
      notices.map((item) => {
        const notice = { ...item };
        if (notice.id === id) {
      
          socket.emit('user.notification.read', { id });
          notice.read = true;

        }
        return notice;
      }),
    );
  };

  const clearReadState = (title: string, key: string) => {
    setNotices(
      notices.map((item) => {
        const notice = { ...item };
        if (notice.type === key && notice.read === false) {
          notice.read = true;
        }
        return notice;
      }),
    );
    // setUnreadCount(0);
  };

  const fetchNotification = async () => {

    const result = await getNotifications({});

    if (result?.success) {


      if (result?.data.length) {
        let test: any = [];

        let dd: any = [];

        dd = [...dd, ...result?.data];

        dd.map((item: any) => {

          test.push({
            id: item._id,
            title: item.title,
            description: item.message,
            type: "notification",
            avatar: 'https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png',
            // type: item?.type?.toLowerCase(),
            datetime: moment(item.createdAt).format('lll'),
            read: item.read,
            userId: item?.userId,
            referenceId: item?.referenceId,
          });
        });

        setNotices(test);
        setUnreadCount(result?.count);
      }

    }


  }

  useEffect(() => {
    fetchNotification();
    setTimeout(() => {
      // socket.emit('user.notification.all');
    }, 1000);
    // socket.on('user.notification.data', (data) => {console.log(data)});
    socket.on('user.notification.reload', () => {

      fetchNotification();
    })
    // socket.on('user.notification.data', (data) => {
    //   console.log('here','user.notification.data')
    //   let test: any = [];

    //   let dd: any = [];
    //   console.log('here')
    //   // ...data.notification, ...data.team, ...data.announcement
    //   if (data) {
    //     dd = [...dd, ...data];
    //   }
    //   // if (data.team) {
    //   //   dd = [...dd, ...data.team];
    //   // }
    //   // if (data.announcement) {
    //   //   dd = [...dd, ...data.announcement];
    //   // }

    // dd.map((item: any) => {
    //   test.push({
    //     id: item._id,
    //     title: item.title,
    //     description: item.message,
    //     avatar: 'https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png',
    //     type: item?.type?.toLowerCase(),
    //     datetime: moment(item.createdAt).format('lll'),
    //     read: item.read,
    //     userId: item?.userId,
    //     referenceId: item?.referenceId,
    //   });
    // });

    // setNotices(test);

    // setUnreadCount(data?.count?.total);
    // setUnreadMsg({
    //   notification: data?.count?.notification,
    //   team: data?.count?.team,
    //   announcement: data?.count?.announcement,
    // });
    // openNotification(data.title, data.notification)
    // });

    socket.on('user.notification.count', (data) => {
  
      setUnreadCount(data?.count);
      // setUnreadCount(data?.count?.total);
      // setUnreadMsg({
      //   notification: data?.count?.notification,
      //   team: data?.count?.team,
      //   announcement: data?.count?.announcement,
      // });
    });

    // socket.on('notificationData', (data) => {
    // });

    return () => {
      socket.off('user.notification.reload');
      // socket.off('user.notification.data');
      socket.off('user.notification.count');
      // socket.off('notificationData');
    };
  }, []);

  // @ts-ignore
  return (
    <>
      <NoticeIcon
        className={styles.action}
        count={unreadCount}
        onItemClick={async (item: any) => {

          if (item?.referenceId) {
            await changeReadState(item.id!);
            // window.open(`/leads/leadView?id=${item?.referenceId}`, '_blank');
            window.open(`/approvals/myList?id=${item?.referenceId}`, '_blank');
          }
          // } 
          // else {
          //   await changeReadState(item.id!);
          // }
          // {`}
        }}
        onBtnClick={() => {
         fetchNotification()}}
        onRead={async (item: any) => {
      
          await changeReadState(item.id!);
          // if (item?.referenceId) {
          //   await changeReadState(item.id!);
          //   window.open(`/leads/leadView?id=${item?.referenceId}`, '_blank');
          // } else {
          //   await changeReadState(item.id!);
          // }
          // {`}
        }}
        onClear={(title: string, key: string) => {
         
          socket.emit('user.notification.read.all', {});
          clearReadState(title, key);
        }}
        loading={false}
        clearText="Read All"
        viewMoreText="View All Notifications"
        onViewMore={() => window.open('/notifications', '_blank')}
        // onViewMore={() => message.info('Click on view more')}
        clearClose
      >


        {/*// @ts-ignore*/}

        <NoticeIcon
          tabKey="notification"
          count={unreadCount}
          onBtnClick={() => fetchNotification()} 
          list={noticeData.notification}
          title="Alert"
          emptyText="No Notifications"
          showViewMore
        />

      </NoticeIcon>
    </>
  );
};

export default NoticeIconView;
